module.exports = __webpack_public_path__ + "static/media/eu.ba189438.jpeg";